import React from "react"

const CallToAction = () => {
  return (
    <section className="call-to-action">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <h2>
              Modern And Clead Design{" "}
              <a href="#" className="btn btn-primary white-border">
                Explore ABout Us
              </a>
            </h2>
          </div>
        </div>
      </div>
    </section>
  )
}

export default CallToAction
